import React, { useState, useRef, useLayoutEffect } from "react";
import { Modal } from "react-bootstrap";
import FlipClock from "../flipClock";
import { getCasinoRulesHtml } from "../../../data/casinoRulesHtml";
import { IS_REF_MOBILE } from "../../../utils/refViewport";

const BALL_IMG = `${import.meta.env.BASE_URL}assets/img/balls/ball-blank.png`;

/**
 * Lucky 15 video in the reference markup (casino/lucky15):
 *   .casino-video.mt-0 > .video-box-container > .video-box > iframe + .cricket20ballpopup (feed rdesc),
 *   .casino-timer (v-show leftTime != 0), .casino-video-right-icons (rules (i)), rules panel + modal.
 */
export default function Lucky15Video({ iframeSrc, timerValue, rdesc, gameType = "lucky15" }) {
  const [showRules, setShowRules] = useState(false);
  const [showRulesModal, setShowRulesModal] = useState(false);
  const rulesHtml = getCasinoRulesHtml(gameType);
  const rootRef = useRef(null);
  const hideTimer = !(Number(timerValue) > 0);

  // Reference: v-show="leftTime != 0" on .casino-timer (FlipClock takes no style prop)
  useLayoutEffect(() => {
    const timer = rootRef.current?.querySelector(":scope > .casino-timer");
    if (timer) timer.style.display = hideTimer ? "none" : "";
  }, [hideTimer]);

  const handleRulesClick = () => {
    if (!rulesHtml) return;
    setShowRules(true);
    // Reference: when IS_MOBILE the rules modal opens too (closing it leaves the panel open)
    if (IS_REF_MOBILE) setShowRulesModal(true);
  };

  return (
    <div className="casino-video mt-0" ref={rootRef}>
      <div className="video-box-container">
        <div className="video-box">
          <iframe src={iframeSrc || undefined} title="Live Stream" allowFullScreen />{" "}
          {rdesc ? (
            <div className="cricket20ballpopup">
              <img src={BALL_IMG} alt="" /> <span>{rdesc}</span>
            </div>
          ) : null}
        </div>
      </div>{" "}
      <FlipClock initialTime={timerValue || 0} />{" "}
      <div className="casino-video-right-icons">
        <div title="Rules" className="casino-video-rules-icon" onClick={handleRulesClick}>
          <i className="fas fa-info-circle" />
        </div>
      </div>{" "}
      <div>
        {showRules && (
          <div
            id="casino-vieo-rules"
            aria-modal="true"
            className="casino-vieo-rules show d-none-small show-rules"
            style={{ display: "block" }}
          >
            <div className="rules-header">
              <div>Rules</div>{" "}
              <i className="fas fa-times" onClick={() => setShowRules(false)} />
            </div>{" "}
            <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml }} />
          </div>
        )}
        <Modal
          show={showRulesModal}
          onHide={() => setShowRulesModal(false)}
          className="casino-rules teenpatti2-rule-modal"
          dialogClassName="modal-md"
          id="rules-modal"
        >
          <header className="modal-header">
            <h5 className="modal-title">Rules</h5>{" "}
            <button type="button" aria-label="Close" className="close" onClick={() => setShowRulesModal(false)}>
              ×
            </button>
          </header>
          <Modal.Body>
            <div className="casino-vieo-rules show-rules show">
              <div className="rules-body" dangerouslySetInnerHTML={{ __html: rulesHtml || "" }} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
